export default function (delay = 500) {
  return (function () {
    const tDelay = delay
    let varTimeout
    return (callback) => {
      clearTimeout(varTimeout)
      varTimeout = setTimeout(callback, tDelay)
    }
  })()
}
